import React from 'react';
import { connect } from 'react-redux';
import { readCookie } from '../../common/Cookie';
import properties from '../../../modules/ajio-util/properties';
import { getIconStyles } from '../../../utils/common';

class BagComponent extends React.Component {
  render() {
    const wishlist = this.props.showWishlist;
    let linkClick = this.props.linkClick;
    let { wishlistCount: wishlistCounter = 0 } = this.props.counter;
    let wishlistCount = wishlistCounter;
    let cookie;
    let {
      metaData: {
        sis = false,
        // textColor = "#FFF",
        current: { headerIconColor, buttonPatchColor } = {}
      } = {}
    } = this.props;

    try {
      cookie = readCookie('nq');
    } catch (error) {
      console.log(`Failed to read cookie : ${error}`);
    }

    if (cookie) {
      let cookieList = cookie.split(':');
      if (cookieList.length) {
        wishlistCount = cookieList[1].split('=')[1];
      }
    }
    const iconStyles = getIconStyles({
      headerIconColor,
      buttonPatchColor
    });
    return (
      <a
        href={`${properties.getProperty('parentUrl')}/wishlist`}
        onClick={() => {
          linkClick('/wishlist', 'Wishlist', 'WishlistClick');
        }}
        className="ic-closet"
        style={iconStyles}
      >
        <div className="ic-wishlist" />
      </a>
    );
  }
}

const mapStateToProps = state => {
  return {
    showWishlist: state.popup.showWislistPopup,
    counter: state.counter,
    metaData: state.metaData
  };
};

export default BagComponent = connect(mapStateToProps, null)(BagComponent);
